import request, { FAIL, SUCCESS } from '../util/Request';
import { AxiosRequestHeaders } from 'axios';

interface SearchForm {
  vocNumber: string;
  phoneNumber: string;
  password: string;
}

interface WriteData {
  title: string;
  content: string;
  name: string;
  password: string;
  phoneNumber: string;
  serviceSortation: string;
  email: string;
  // optional file name metadata (only `fileName` remains)
  fileName?: string | null;
}

interface IVocCreateResponse {
  status: string;
  data?: unknown;
}

const UserBoardService = {
  writeVoc: async (
    writeData: WriteData,
    uploadFiles?: Record<string, Blob | null>
  ): Promise<IVocCreateResponse> => {
    const formData = new FormData();
    const keys = Object.keys(writeData);
    for (const k of keys) {
      const value = writeData[k as keyof WriteData];
      // only append defined and non-null primitive values
      if (value !== undefined && value !== null) {
        formData.append(k, String(value));
      }
    }

    if (uploadFiles) {
      const fileKeys = Object.keys(uploadFiles);
      for (const fk of fileKeys) {
        const file = uploadFiles[fk];
        if (file) {
          formData.append(fk, file);
        }
      }
    }

    // debug: log FormData entries for troubleshooting upload fields
    if (process.env.NODE_ENV !== 'production') {
      // Note: Check specific keys to confirm which files/fields were appended (avoids iterating FormData)
      const keysToCheck = ['attachment', 'fileName'];
      for (const k of keysToCheck) {
        const v = formData.get(k as string);
        if (v !== null) console.debug('FormData append ->', k, v);
      }
    }

    try {
      const headers = { 'Content-Type': 'multipart/form-data' } as unknown as AxiosRequestHeaders;
      const response = await request.post(`/vocCreate`, formData, {
        headers
      });
      if (request.isSuccess(response)) {
        return {
          ...response,
          status: SUCCESS
        };
      }
      return { status: FAIL };
    } catch (error) {
      return {
        status: FAIL
      };
    }
  },
  searchVoc: async (formData: SearchForm) => {
    const no = formData.vocNumber;
    const phoneNumber = formData.phoneNumber;
    const password = formData.password;
    try {
      const response = await request.get(
        `/vocSearch?no=${no}&phoneNumber=${phoneNumber}&password=${password}`
      );

      if (request.isSuccess(response)) {
        return {
          ...response,
          status: SUCCESS
        };
      }
      return { status: FAIL };
    } catch (error) {
      return {
        status: FAIL
      };
    }
  }
};
export default UserBoardService;
